import { render, staticRenderFns } from "./C-3-1a-6__ProductInfoEdit_ProductDescriptionKSP.vue?vue&type=template&id=78c41ecb&"
import script from "./C-3-1a-6__ProductInfoEdit_ProductDescriptionKSP.vue?vue&type=script&lang=js&"
export * from "./C-3-1a-6__ProductInfoEdit_ProductDescriptionKSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCombobox,VIcon})
